"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermittableFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var PermittableFactory = /** @class */ (function (_super) {
    __extends(PermittableFactory, _super);
    function PermittableFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    PermittableFactory.prototype.deploy = function (name, version, overrides) {
        return _super.prototype.deploy.call(this, name, version, overrides || {});
    };
    PermittableFactory.prototype.getDeployTransaction = function (name, version, overrides) {
        return _super.prototype.getDeployTransaction.call(this, name, version, overrides || {});
    };
    PermittableFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    PermittableFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    PermittableFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return PermittableFactory;
}(contracts_1.ContractFactory));
exports.PermittableFactory = PermittableFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "version",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        constant: true,
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "PERMIT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b506040516103723803806103728339818101604052604081101561003357600080fd5b810190808051604051939291908464010000000082111561005357600080fd5b90830190602082018581111561006857600080fd5b825164010000000081118282018810171561008257600080fd5b82525081516020918201929091019080838360005b838110156100af578181015183820152602001610097565b50505050905090810190601f1680156100dc5780820380516001836020036101000a031916815260200191505b50604052602001805160405193929190846401000000008211156100ff57600080fd5b90830190602082018581111561011457600080fd5b825164010000000081118282018810171561012e57600080fd5b82525081516020918201929091019080838360005b8381101561015b578181015183820152602001610143565b50505050905090810190601f1680156101885780820380516001836020036101000a031916815260200191505b5060405250505061019f82826101aa60201b60201c565b6000555061021f9050565b604051600090469080605261032082396040805191829003605201822087516020808a01919091208851898301208286019390935284840152606084019190915260808301949094523060a0808401919091528151808403909101815260c09092019052805192019190912091505092915050565b60f38061022d6000396000f3fe6080604052348015600f57600080fd5b5060043610603c5760003560e01c806330adf81f1460415780633644e5151460595780637ecebe0014605f575b600080fd5b60476082565b60408051918252519081900360200190f35b604760a6565b604760048036036020811015607357600080fd5b50356001600160a01b031660ac565b7f6e71edae12b1b97f4d1f60370fef10105fa2faae0126114a169c64845d6126c981565b60005481565b6001602052600090815260409020548156fea265627a7a72315820a8d4242fadb6b8dc239d7af9e7834f5a6d8795a3db92e63a08aceb3e656dce9d64736f6c63430005100032454950373132446f6d61696e28737472696e67206e616d652c737472696e672076657273696f6e2c75696e7432353620636861696e49642c6164647265737320766572696679696e67436f6e747261637429";
